import type { Component, Entity2D } from '../../odie';

import { CoolerBlockProps, CountBlockOptionDef } from '../defs/block';
import { CoolerBlockView } from '../views/blocks/CoolerBlockView';

export type CoolerBlockComponentOptions = {
  props: CoolerBlockProps;
  option?: number;
};

export class CoolerBlockComponent implements Component {
  public static readonly NAME = 'blockCooler';

  public entity!: Entity2D;
  public view!: CoolerBlockView;
  public triggered = false;
  private props!: CoolerBlockProps;

  public init(args: CoolerBlockComponentOptions): void {
    // get option def
    const optionDef = args.props.options?.[
      args.option || 0
    ] as CountBlockOptionDef;

    this.props = args.props;

    // create view
    this.view = new CoolerBlockView(args.props);

    // set initial count
    this.count = optionDef.count;

    // Set the getGameplayState retrieval function
    this.entity.c.block.getGameplayState = () => this.getGameplayState();
  }

  public getGameplayState(): number {
    const options = this.props.options as CountBlockOptionDef[];
    return options.findIndex((opt) => {
      return opt.count === this.view.count;
    });
  }

  public get count(): number {
    return this.view.count;
  }

  public set count(value: number) {
    this.view.count = value;
  }
}
